const mergeTags = function(facetsAll, facetsActual, selected_param) {


    let no_actual_facets = false;
    if(facetsActual === null || !facetsActual.length) {
        no_actual_facets = true;
    }

    facetsAll.forEach(function (facet, facet_idx) {

        // пустой массив если такой фасет отсутствует в facetsActual или фасет из facetsActusl
        let selected = [];

        if(!no_actual_facets) {
            selected = facetsActual.filter(function (selected_item) {
                return facet.name === selected_item.name;
            });
        }

        if(selected.length) {
            let selected_values = selected[0]['values']; // массив объектов values

            let same_param = false;
            if(selected_param === selected[0]['name']) {
                // ставим enabled для всех values параметра
                same_param = true;
            }

            facet.values.forEach(function (value_obj, value_obj_idx) {
                for(let idx in value_obj) {
                    let selected_value = selected_values.filter(function (value) {
                        return value['id'] === value_obj['id'];
                    })

                    if(same_param) {
                        continue;
                    }

                    if(selected_value.length) {
                        facetsAll[facet_idx]['values'][value_obj_idx]['value'] = selected_value[0].value;
                        facetsAll[facet_idx]['values'][value_obj_idx]['enabled'] = true;
                    } else {
                        facetsAll[facet_idx]['values'][value_obj_idx]['value'] = 0
                        facetsAll[facet_idx]['values'][value_obj_idx]['enabled'] = false;
                    }
                }
            });
        } else {
            facet.values.forEach(function (value_obj, value_obj_idx) {
                facetsAll[facet_idx]['values'][value_obj_idx]['value'] = 0
                facetsAll[facet_idx]['values'][value_obj_idx]['enabled'] = false;
            });
        }
    });
};

/**
 *
 * @param facetsAll         все фасеты (например все бренды выборки)
 * @param facetsActual      фасеты из текущей выборки (например часть брендов)
 * @param selected_param    напр: brand
 */
const mergeFacets = function(facetsAll, facetsActual, selected_param, param) {

    let no_actual_facets = false;
    if(facetsActual === null || !facetsActual.length) {
        no_actual_facets = true;
    }
    let same_param = (param === selected_param);

    if(same_param) {
        return;
    }

    facetsAll.forEach(function (facet, facet_idx) {

        if(no_actual_facets) {
            facet.value = 0;
            facet.enabled = false;

        } else {
            // selected - пустой массив если такой фасет отсутствует в facetsActual
            let selected = facetsActual.filter(function (selected_item) {
                return facet.name === selected_item.name;
            });

            if(selected.length) {
                facet.value = selected[0].value;
                facet.enabled = true;
            } else {
                facet.value = 0;
                facet.enabled = false;
            }
        }
    });
}

const filterFacets = function (facets, name) {
    const items = facets.filter((item) => {
        return item.name === name
    });
    return (typeof items[0] !== 'undefined') ? items[0].values : [];
};

const removeValue = function(list, value, separator) {
    separator = separator || ",";
    var values = list.split(separator);
    var index = values.indexOf(value);
    if(index >= 0) {
        values.splice(index, 1);
        return values.join(separator);
    } else {
        return list;
    }
}
const addValue = function(list, value, separator) {
    list = removeValue(list, value, separator);
    separator = separator || ",";
    var values = list.split(separator);
    values.push(value);
    return values.join(separator);
}


const setParams = function (data) {
    let {queryFilters, q, sort, pageSize, currentPage, selected_category, searchParam} = data;

    let params = new URLSearchParams();
    params.append(searchParam, 'true');
    params.append('q', q);
    if(queryFilters.length) {
        queryFilters.forEach(function (value) {
            for(let v in value) {
                params.append(v, value[v]);
            }
        })
    }
    params.append('category', selected_category);
    params.append('sort', sort);
    params.append('size', pageSize);

    if(currentPage < 0) {
        currentPage = 0;
    }
    params.append('offset', pageSize*currentPage);

    return params;
};


const formatter = function () {
    return  new Intl.NumberFormat('ru-RU', {
        style: 'decimal',
        currency: 'RUB',
        maximumFractionDigits: 0,
    });
}

function getPath() {
    return location.pathname + location.search + location.hash;
}

function getCorrectPlural(e, t) {
    var r = t % 100 < 10 || t % 100 > 19 ? ["ов", "", "а", "а", "а", "ов", "ов", "ов", "ов", "ов"][t % 10] : "ов";
    return "".concat(e).concat(r);
}

function getCoordinates(headerSelector) {
    let e = document.querySelector(headerSelector);
    if (e) return { top: e.getBoundingClientRect().top + e.offsetHeight, left: 0 };
}

export default {
    mergeTags,
    mergeFacets,
    removeValue,
    addValue,
    filterFacets,
    setParams,
    formatter,
    getCorrectPlural,
    getCoordinates
}
